<div class="layout-container">
  <!-- Sidebar -->
  <div class="sidebar">
    <app-navigation></app-navigation>
  </div>
  <!-- Main Content (toolbar above router-outlet) -->
  <div class="main-content">
    <app-toolbar></app-toolbar>
    <p-toast (onClose)="onToastClosed()"></p-toast>
    <router-outlet>
    </router-outlet>
  </div>
</div>